import React from "react";

const Election = () => {
    return;
}

export default Election;